<mat-toolbar color="primary">
  <mat-toolbar-row class="popupTitle">
    <span>{{notification.title}}</span>
  </mat-toolbar-row>
</mat-toolbar>
<mat-dialog-content class="mat-typography dialog-content">
  <h2>{{notification.message}}</h2>
</mat-dialog-content>
<mat-dialog-actions color="primary" align="end">
  <div *ngFor="let action of notification.actions; let last = last">
    <button *ngIf="!last" mat-button [mat-dialog-close]="{callback: action.callback}" class="smarticle_text_btn">{{action.text}}</button>
    <button *ngIf="last" mat-raised-button [mat-dialog-close]="{callback: action.callback}" color="primary" class="smarticle_text_btn" cdkFocusInitial>{{action.text}}</button>
  </div>
</mat-dialog-actions>
